import { render } from "./RiceMainCourse.vue?vue&type=template&id=48136c82"
import script from "./RiceMainCourse.vue?vue&type=script&lang=js"
export * from "./RiceMainCourse.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__